export const formatDate = (iso: string | null) => {
  if (!iso) return 'Never';

  return new Date(iso).toLocaleDateString();
};

export const formatDateTime = (iso: string | null) => {
  if (!iso) return 'Never';

  return new Date(iso).toLocaleString(undefined, { dateStyle: 'short', timeStyle: 'short' });
};
